import { LegacyTvChannelPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getChannelFragment } from './get-channel-fragment';

export const getChannelOnlineStreams = (channel: LegacyTvChannelPlayerBaseInfoContent | null) =>
    getChannelFragment(channel)?.onlineStreams ?? undefined;
